import { API } from 'aws-amplify';

const API_NAME = 'REST';

const api = {
  getOrganizations: async () => API.get(API_NAME, 'organizations'),

  createOrganization: async (organization) => API.post(API_NAME, 'organizations', { body: organization }),

  getOrganization: async (organizationId) => API.get(API_NAME, `organizations/${organizationId}`),

  getOrganizationsByUser: async (userId) => API.get(API_NAME, `organizations?userId=${userId}`),

  getOrganizationUsers: async (organizationId) => API.get(API_NAME, `users?organizationId=${organizationId}`),

  getUserRoles: async (userId) => API.get(API_NAME, `users/${userId}/roles`),

  updateUserProfile: async (userId, profile) => API.post(API_NAME, `/users/${userId}`, { body: profile }),

  updateOrganizationUser: async (organizationId, details, role) =>
    API.post(API_NAME, `organizations/${organizationId}/users`, { body: { details, role } }),

  updateOrganization: async (organization) =>
    API.post(API_NAME, `organizations/${organization.id}`, { body: organization }),

  getOrganizationAssessments: async (organizationId) => API.get(API_NAME, `assessments/${organizationId}`),

  getOrganizationAssessmentsOfType: async (organizationId, assessmentType) =>
    API.get(API_NAME, `assessments/${organizationId}/${assessmentType}`),

  createOrganizationAssessment: async (organizationId, assessment) =>
    API.post(API_NAME, `assessments/${organizationId}`, { body: assessment }),

  getOrganizationAssessment: async (organizationId, assessmentId, assessmentType) =>
    API.get(API_NAME, `assessments/${organizationId}/${assessmentType}/${assessmentId}`),

  updateOrganizationAssessment: async (organizationId, assessment) =>
    API.post(API_NAME, `assessments/${organizationId}/${assessment.assessmentType}/${assessment.id}`, {
      body: assessment,
    }),

  getOrganizationContacts: async (organizationId) => API.get(API_NAME, `contacts/${organizationId}`),

  createContact: async (organizationId, contactDetails) =>
    API.post(API_NAME, `contacts/${organizationId}`, { body: contactDetails }),

  updateContact: async (organizationId, contactId, contactDetails) =>
    API.post(API_NAME, `contacts/${organizationId}/${contactId}`, { body: contactDetails }),

  getOrganizationActivities: async (organizationId) => API.get(API_NAME, `activities/${organizationId}`),

  createActivity: async (organizationId, activity) =>
    API.post(API_NAME, `activities/${organizationId}`, { body: activity }),

  updateActivity: async (organizationId, activity) =>
    API.post(API_NAME, `activities/${organizationId}/${activity.id}`, {
      body: activity,
    }),

  getAssessmentFindings: async (assessmentId) => API.get(API_NAME, `findings/${assessmentId}`),

  getOrganizationFindings: async (parentId) => API.get(API_NAME, `findings?parentId=${parentId}`),

  getFinding: async (assessmentId, findingId) => API.get(API_NAME, `findings/${assessmentId}/${findingId}`),

  createFinding: async (assessmentId, finding) =>
    API.post(API_NAME, `findings/${assessmentId}`, { body: finding }),

  updateFinding: async (assessmentId, finding) =>
    API.post(API_NAME, `findings/${assessmentId}/${finding.id}`, {
      body: finding,
    }),

  deleteFinding: async (assessmentId, findingId) => API.del(API_NAME, `findings/${assessmentId}/${findingId}`),

  getStandardFrameworks: async () => API.get(API_NAME, 'frameworks'),

  getCustomFrameworks: async (organizationId) => API.get(API_NAME, `frameworks/${organizationId}`),

  createStandardFramework: async (framework) => API.post(API_NAME, 'frameworks', { body: framework }),

  createCustomFramework: async (organizationId, framework) =>
    API.post(API_NAME, `frameworks/${organizationId}`, { body: framework }),

  updateCustomFramework: async (organizationId, frameworkId, framework) =>
    API.post(API_NAME, `frameworks/${organizationId}/${frameworkId}`, { body: framework }),

  createSoa: async (organizationId, frameworkId, soa) =>
    API.post(API_NAME, `frameworks/${organizationId}/${frameworkId}/soas`, { body: soa }),

  getSoas: async (organizationId, frameworkId) =>
    API.get(API_NAME, `frameworks/${organizationId}/${frameworkId}/soas`),
};

export default api;
